// extracted by mini-css-extract-plugin
module.exports = {"evidence-form-wrapper":"ActionAddEditEvidence_evidence-form-wrapper__3KijZ"};